import { useEffect } from "react";
import {
  MAIN_PAGE_COLORS,
  MAIN_PAGE_FONT_STACK,
} from "../theme/mainPageVisual";
import "./CognitoryLibraryShell.css";

export type CognitoryLibraryToastProps = {
  message: string;
  secondaryMessage?: string | null;
  variant?: "success" | "error";
  onDismiss: () => void;
  autoDismissMs?: number;
};

export function CognitoryLibraryToast({
  message,
  secondaryMessage,
  variant = "success",
  onDismiss,
  autoDismissMs = 5500,
}: CognitoryLibraryToastProps) {
  useEffect(() => {
    const timer = window.setTimeout(onDismiss, autoDismissMs);
    return () => {
      window.clearTimeout(timer);
    };
  }, [autoDismissMs, message, onDismiss]);

  return (
    <div
      className={`cognitory-library-toast cognitory-library-toast--${variant}`}
      data-testid="cognitory-library-toast"
      role="status"
      aria-live="polite"
      aria-atomic="true"
      style={{ fontFamily: MAIN_PAGE_FONT_STACK }}
    >
      <p
        data-testid="cognitory-library-toast-message"
        className="cognitory-library-toast-message"
        style={{
          color:
            variant === "error"
              ? MAIN_PAGE_COLORS.alertInk
              : MAIN_PAGE_COLORS.inkStrong,
        }}
      >
        {variant === "success" ? (
          <span className="cognitory-library-toast-check" aria-hidden="true">
            ✓{" "}
          </span>
        ) : null}
        {message}
      </p>
      {secondaryMessage ? (
        <p
          data-testid="cognitory-library-toast-secondary"
          className="cognitory-library-toast-secondary"
          style={{ color: MAIN_PAGE_COLORS.slate }}
        >
          {secondaryMessage}
        </p>
      ) : null}
    </div>
  );
}
